import { render, staticRenderFns } from "./RTPList.vue?vue&type=template&id=b84cf8f6&"
import script from "./RTPList.vue?vue&type=script&lang=js&"
export * from "./RTPList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports